import { isPlatformServer, Location } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { Router } from '@angular/router';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { BreakpointWidthEnum } from '~/core/enums/breakpoint-width.enum';
import { ErrorCodeService } from '~/core/services/error-code/error-code.service';
import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';
import { RedirectionService } from '~/core/services/redirection/redirection.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';
import { ToggleService } from '~/toggles/services/toggle.service';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { VtmnPlayButtonVariantStyleEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant-style.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  public readonly mdScreenSize = `(min-width:${BreakpointWidthEnum.MD}px)`;
  public readonly notFoundIcon = VtmnPlayIconTypeEnum.EmotionUnhappy;
  public readonly toggleNameEnum = ToggleNameEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonStyle = VtmnPlayButtonVariantStyleEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public errorCode = ErrorCodesEnum.No;
  public isUnauthorized: boolean;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: string,
    @Optional() @Inject(RESPONSE) private readonly response: Response,
    private readonly errorCodeService: ErrorCodeService,
    private readonly redirectionService: RedirectionService,
    private readonly router: Router,
    protected readonly toggleService: ToggleService,
    public readonly location: Location
  ) {}

  public ngOnInit(): void {
    this.errorCode = this.errorCodeService.getCurrentCode();
    this.isUnauthorized = this.errorCode === '10';

    if (isPlatformServer(this.platformId)) {
      this.response.status(404);
    }

    // In case of error in URL locale
    if (this.toggleService.isEnabled(ToggleNameEnum.LocalesLanguagesList)) {
      this.checkLocaleError();
    }

    // Reinitialization for the next error.
    // If you don't do that, you can't know if the next error is a 404 (0) or an other error.
    this.errorCodeService.pushCode(ErrorCodesEnum.No);
  }

  private checkLocaleError(): void {
    const list = this.toggleService.getVariantString(
      this.toggleNameEnum.LocalesLanguagesList,
      'bg-BG,de-CH,en-CA,en-CH,en-GB,en-ID,en-MY,en-SG,en-TH,en-US,es-CL,es-CO,es-ES,es-MX,fr-CA,fr-CH,fr-FR,id-ID,it-CH,it-IT,pt-PT,th-TH'
    );
    const locale = this.router.url.split('/')[1];

    if (!list.includes(locale)) {
      this.redirectionService.redirect('/');
    }
  }
}
